module.exports = __webpack_public_path__ + "img/ZB_logo.99ddb7aa.webp";